import { render, staticRenderFns } from "./ClassScore.vue?vue&type=template&id=f84c93fc&scoped=true&"
import script from "./ClassScore.vue?vue&type=script&lang=js&"
export * from "./ClassScore.vue?vue&type=script&lang=js&"
import style0 from "./ClassScore.vue?vue&type=style&index=0&id=f84c93fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84c93fc",
  null
  
)

export default component.exports